<span [class]="data.geactiveerd">
  {{data.leermiddelNaam}}
</span>
